module.exports = __webpack_public_path__ + "static/media/details-24-image-1.73245cca.jpg";